import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<TournamentPositionsResponse, { tournamentId: number; categoryId: number }>({
    query: ({ tournamentId, categoryId }) => ({
      url: `v4/pitch-owner/tournaments/${tournamentId}/custom/teams/${categoryId}/positions`,
      method: 'Get',
    }),
  });

type TournamentPositionsResponse = {
  data: Position[];
};

export interface Position {
  id: number;
  name: string;
  team_number: number;
  position: number | null;
  players_names: string;
  team_players: Player[];
}

export interface Player {
  id: number;
  name: string;
  phone: number;
}
